import React, { memo } from 'react';

import { Button } from '@mui/material';
import { ButtonGroupWrapper } from '@sharedCR/coreDesignSystem/Buttons';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

import { usePrepareDisclosuresWizard } from '../../hooks';
import { POST_SEND_COPY } from '../../PrepareDisclosuresWizard.constants';
import { PrepareDisclosuresWizardTestIds } from '../../PrepareDisclosuresWizard.testIds';

const PrepareDisclosuresWizardFooter = () => {
  const {
    steps,
    activeStepIndex,
    isFirstStep,
    isLastStep,
    canContinue,
    canSubmit,
    isSent,
    goBack,
    goNext,
    submit,
    requestClose,
  } = usePrepareDisclosuresWizard();

  if (isSent) {
    return (
      <ButtonGroupWrapper
        alignment={HORIZONTAL_ALIGNMENT.RIGHT}
        className="w-full"
        data-testid={PrepareDisclosuresWizardTestIds.FOOTER}
      >
        <Button
          color="primary"
          data-testid={PrepareDisclosuresWizardTestIds.BACK_TO_LOAN_BUTTON}
          variant="contained"
          onClick={requestClose}
        >
          {POST_SEND_COPY.backToLoan}
        </Button>
      </ButtonGroupWrapper>
    );
  }

  const continueLabel = steps[activeStepIndex]?.continueLabel ?? 'Continue';
  const secondaryLabel = isFirstStep ? 'Cancel' : 'Back';
  const onSecondaryClick = isFirstStep ? requestClose : goBack;
  const onPrimaryClick = isLastStep ? submit : goNext;
  const isPrimaryDisabled = isLastStep ? !canSubmit : !canContinue;

  return (
    <ButtonGroupWrapper
      alignment={HORIZONTAL_ALIGNMENT.RIGHT}
      className="w-full"
      data-testid={PrepareDisclosuresWizardTestIds.FOOTER}
    >
      <Button
        data-testid={PrepareDisclosuresWizardTestIds.BACK_BUTTON}
        variant="outlined"
        onClick={onSecondaryClick}
      >
        {secondaryLabel}
      </Button>
      <Button
        color="primary"
        data-testid={PrepareDisclosuresWizardTestIds.CONTINUE_BUTTON}
        disabled={isPrimaryDisabled}
        variant="contained"
        onClick={onPrimaryClick}
      >
        {continueLabel}
      </Button>
    </ButtonGroupWrapper>
  );
};

export default memo(PrepareDisclosuresWizardFooter);
